export function obtenirUrlControleur(nomControleur) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    if (apiBaseUrl && apiBaseUrl.trim().length > 0) {
        return apiBaseUrl.replace(/\/$/, '');
    }

    return window.location.origin;
}